// extracted by mini-css-extract-plugin
export default {"root":"root_S0Pk","title":"title_lCT1","image":"image_B1Xl"};